// Mapping of Excel header cells to user data fields
export const excelHeaderCellsName = {
  المعرف: "id",
  " الاسم": "displayName",
  "رقم الهاتف": "phoneNumber",
  "البريد الإلكتروني": "email",
};
